import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';
import { DoorConstruction } from '../types/door-construction';
import { ProductLine } from '../types/product-line';


@Injectable()
export class ProductLineService {
  constructor( private http: HttpClient) 
  {
  }

    getProductLines(): Observable<any> {  
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const requestOptions = {headers};   
    return this.http.get<Array<ProductLine>>(`${environment.apiQwikkitOrdering}api/apartmentComplex/GetProductLines`, requestOptions);
  }
}